import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;

export const disneySocialThisMonth = defineTemplate({
  mode: 'legacy',
  id: 'social-this-month',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Este mes',
  disabled: true,
  hiddenFromUI: true,
  thumbnail: {
    url: `${BASE}/thumbnails/este_mes.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/este_mes.png`,
    hoverVideo: `${BASE}/previews/este_mes_julio.mp4`,

    aspectRatio: 'vertical'
  },
  formFields: []
});
